module.exports = __webpack_public_path__ + "img/logo-mum-320x63.d7c690c3.png";